function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable react/button-has-type */
import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "@xo-union/tk-component-icons";
import classNames from "classnames";
import styles from "./styles.css";
var ImageWithDecode = function ImageWithDecode(_ref) {
  var src = _ref.src,
    description = _ref.description;
  var _useState = useState('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  React.useEffect(function () {
    var img = new Image();
    img.src = src;
    var handleLoad = function handleLoad() {
      setStatus('loaded');
    };
    var handleError = function handleError(err) {
      setStatus("error: ".concat(err.message));
    };
    if (img.decode) {
      img.decode().then(handleLoad)["catch"](handleError);
    } else {
      img.onload = handleLoad;
      img.onerror = handleError;
    }
  }, [src]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    className: status === 'loaded' ? null : styles.skeleton,
    src: "".concat(src),
    alt: description
  }));
};
export default function MosaicImageItem(_ref2) {
  var option = _ref2.option,
    handleSelectOption = _ref2.handleSelectOption,
    isSelected = _ref2.isSelected,
    maxImagesSelected = _ref2.maxImagesSelected;
  var imageId = option.imageId,
    description = option.description;
  var buttonClasses = classNames(styles['mosaic-image-item'], _defineProperty({}, styles.isSelected, isSelected));
  var whiteLayerClasses = classNames(styles['white-layer'], _defineProperty({}, styles.maxImagesSelected, maxImagesSelected && !isSelected));
  var iconClasses = classNames(styles['selection-icon'], _defineProperty({}, styles.isSelected, isSelected));
  function handleClick() {
    handleSelectOption(option);
  }
  return /*#__PURE__*/React.createElement("button", {
    "data-testid": "style-quiz-mosaic-image-item",
    style: {
      position: 'relative'
    },
    onClick: handleClick,
    className: buttonClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: whiteLayerClasses
  }), /*#__PURE__*/React.createElement(ImageWithDecode, {
    src: "https://media-api.xogrp.com/images/".concat(imageId),
    description: description
  }), /*#__PURE__*/React.createElement(Icon, {
    name: isSelected ? 'check' : '',
    size: "md",
    className: iconClasses
  }));
}
process.env.NODE_ENV !== "production" ? MosaicImageItem.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    imageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    facet: PropTypes.string,
    seoUrl: PropTypes.string
  }).isRequired,
  handleSelectOption: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  maxImagesSelected: PropTypes.bool.isRequired
} : void 0;
process.env.NODE_ENV !== "production" ? ImageWithDecode.propTypes = {
  src: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
} : void 0;